import clsx, { ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
import data from "./font_variants.json";

// https://github.com/dcastil/tailwind-merge/blob/v1.14.0/docs/configuration.md
const customTwMerge = extendTailwindMerge({
  classGroups: {
    fontVariants: Array.isArray(data) ? data : [],
  },
});

export const clsxm = (...classes: ClassValue[]) => customTwMerge(clsx(classes));
